import React, { useEffect, useState } from 'react';

export const mobilePaginationItems = (page, pageCount) => {
  const numbers = new Set([1, pageCount, page - 1, page, page + 1]);
  if (page <= 2) [2, 3].forEach(number => numbers.add(number));
  if (page >= pageCount - 1) [pageCount - 2, pageCount - 1].forEach(number => numbers.add(number));
  if (pageCount <= 5) for (let number = 1; number <= pageCount; number++) numbers.add(number);
  const visible = [...numbers]
    .filter(number => number >= 1 && number <= pageCount)
    .sort((a, b) => a - b);
  const result = [];
  visible.forEach((number, index) => {
    if (index && number - visible[index - 1] > 1) result.push(`gap-${number}`);
    result.push(number);
  });
  return result;
};

export default function MobileProductsPagination({
  page,
  pageCount,
  loading,
  onChange,
  compact = false,
}) {
  const [target, setTarget] = useState(String(page));
  const [jump, setJump] = useState(false);
  useEffect(() => {
    setTarget(String(page));
    setJump(false);
  }, [page]);
  const valid = /^\d+$/.test(target) && Number(target) >= 1 && Number(target) <= pageCount;
  const go = number => {
    if (!loading && number >= 1 && number <= pageCount && number !== page) onChange(number);
  };
  return (
    <nav
      className={`mp-pagination${compact ? ' mp-pagination-compact' : ''}`}
      aria-label='Сторінки товарів'
      onKeyDown={event => {
        if (compact && event.key === 'Escape') setJump(false);
      }}
      onBlur={event => {
        if (compact && !event.currentTarget.contains(event.relatedTarget)) setJump(false);
      }}
    >
      <div className='mp-pagination-numbers'>
        <button
          type='button'
          disabled={loading || page <= 1}
          onClick={() => go(page - 1)}
          aria-label='Попередня сторінка'
        >
          <i className='bi bi-chevron-left' aria-hidden='true' />
        </button>
        {compact ? (
          <button
            type='button'
            className='mp-page-jump-toggle'
            aria-label={`Сторінка ${page} із ${pageCount}. Перейти на іншу сторінку`}
            aria-current='page'
            aria-expanded={jump}
            disabled={loading}
            onClick={() => setJump(value => !value)}
          >
            {page}
            <i className={`bi bi-chevron-${jump ? 'up' : 'down'}`} aria-hidden='true' />
          </button>
        ) : (
          mobilePaginationItems(page, pageCount).map(item =>
            typeof item === 'number' ? (
              <button
                key={item}
                type='button'
                aria-label={`Сторінка ${item}`}
                aria-current={item === page ? 'page' : undefined}
                disabled={loading}
                onClick={() => go(item)}
              >
                {item}
              </button>
            ) : (
              <span key={item} className='mp-pagination-gap' aria-hidden='true'>
                …
              </span>
            ),
          )
        )}
        <button
          type='button'
          disabled={loading || page >= pageCount}
          onClick={() => go(page + 1)}
          aria-label='Наступна сторінка'
        >
          <i className='bi bi-chevron-right' aria-hidden='true' />
        </button>
      </div>
      {!compact && (
        <div className='mp-pagination-caption' aria-live='polite'>
          {pageCount > 5 ? (
            <button
              type='button'
              className='mp-page-jump-toggle'
              aria-expanded={jump}
              disabled={loading}
              onClick={() => setJump(value => !value)}
            >
              Сторінка {page} із {pageCount}{' '}
              <i className={`bi bi-chevron-${jump ? 'up' : 'down'}`} aria-hidden='true' />
            </button>
          ) : (
            <span>
              Сторінка {page} із {pageCount}
            </span>
          )}
        </div>
      )}
      {jump && (
        <form
          className='mp-page-jump'
          onSubmit={event => {
            event.preventDefault();
            if (valid) go(Number(target));
          }}
        >
          <label>
            {compact ? `Сторінка (1–${pageCount})` : 'Перейти на'}
            <input
              className='form-control form-control-sm'
              type='number'
              min='1'
              max={pageCount}
              inputMode='numeric'
              value={target}
              onChange={event => setTarget(event.target.value)}
              disabled={loading}
              autoFocus={compact}
            />
          </label>
          <button type='submit' className='btn btn-sm btn-dark' disabled={!valid || loading}>
            Перейти
          </button>
        </form>
      )}
    </nav>
  );
}
